module.exports = __webpack_public_path__ + "0d559119691c05b641bde10f39efbbc0.jpg";